import { ResetPasswordPage } from '@/pages/reset-password';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/auth/reset-password')({
	component: ResetPasswordPage,
	validateSearch: (search) => {
		return {
			token: search.token?.toString(),
			redirect_uri: search.redirect_uri?.toString(),
		};
	},
});
